import {
  createSlice,
  handleFilters,
  handleFilterConfigs,
  handleDefaultParams,
  replaceFilters,
  restoreFilterSnapshot,
  copyFilterSnapshot,
  applyFilter,
  removeFilter
} from "../helper";

const profileQuestionFiltersSlice = createSlice({
  name: 'ProfileQuestionFilters',
  initialState: {},
  reducers: {
    handleProfileQuestionFilters(prevState, action) {
      handleFilters(prevState, action);
    },
    handleProfileQuestionFilterConfigs(prevState, action) {
      handleFilterConfigs(prevState, action);
    },
    handleProfileQuestionDefaultParams(prevState, action) {
      handleDefaultParams(prevState, action);
    },
    replaceProfileQuestionFilters(_prevState, action) {
      return replaceFilters(_prevState, action);
    },
    restoreProfileQuestionFilterSnapshot(prevState, action) {
      restoreFilterSnapshot(prevState, action);
    },
    copyProfileQuestionFilterSnapshot(prevState, action) {
      copyFilterSnapshot(prevState, action);
    },
    applyProfileQuestionFilter(prevState, action) {
      applyFilter(prevState, action);
    },
    removeProfileQuestionFilter(prevState, action) {
      removeFilter(prevState, action);
    }
  }
});

export const filterActions = profileQuestionFiltersSlice.actions;

export default profileQuestionFiltersSlice;
